// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__li-tW","button":"styles_button__b3bK7","leftColumn":"styles_leftColumn__fnV0s","buttonContainer":"styles_buttonContainer__e5s4i"};